export default __webpack_public_path__ + "static/media/Boostrap.f132cb79.png";